import { useEffect, useState, useRef } from 'react';
import { useResizeScreen } from "../../../hooks/useResizeScreen";
import useStyles from "../../../assets/styles/styles";
import {
    Typography,
    Divider,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    IconButton,
    CircularProgress,
    Box
} from "@material-ui/core";
import CustomButton from '../../../controls/Button/CustomButton';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import { getDataWheightHeight } from './../../../redux/actions/medicalDataAction';
import { useDispatch, useSelector } from "react-redux";
import MovementsCard from "../../Billing/Movements/MovementsCard";
import HeaderCard from '../../Billing/Movements/HeaderCard';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { handleGoToPersonalMedicalData } from "../../../utils/utilsFunctions";
import ShowPeriodFilter from "../../../components/ShowPeriodFilter/ShowPeriodFilter";
import RenderAccordionDetail from './RenderAccordionDetail';
import MedicalHistoryWeightHeightCard from './MedicalHistoryWeightHeightCard';

const WeightAndHeigth = (props) => {
    const today = new Date();
    const sixMonthsAgo = new Date(today.getFullYear(), today.getMonth() - 6, today.getDate());
    const dispatch = useDispatch();
    const classes = useStyles();
    const { screen } = useResizeScreen();
    const [open, setOpen] = useState(false);
    const [dateStart, setDateStart] = useState(sixMonthsAgo);
    const [dateEnd, setDateEnd] = useState(today);
    const [listRegister, setListRegister] = useState([]);
    const [lastRecord, setLastRecord] = useState(null);
    const [skip, setSkip] = useState(0);
    const [initial, setInitial] = useState(true);
    const medicalData = useSelector(state => state.medicalDataReducer);
    const [loading, setLoading] = useState(true);
    const lastRequest = useRef(null);

    useEffect(() => {
        if (medicalData.weightHeight?.pesoTalla !== undefined && medicalData.weightHeight?.pesoTalla?.length > 0) {

            if (listRegister.length !== 0) {
                const newRegisters = listRegister;
                medicalData.weightHeight.pesoTalla.forEach(element => {
                    newRegisters.push(element);
                });
                setListRegister(newRegisters);
            } else {
                if (initial) {
                    setLastRecord(medicalData.weightHeight.pesoTalla[0]);
                    setInitial(false);
                }
                setListRegister(medicalData.weightHeight.pesoTalla);
            }

        }
        setLoading(false);
    }, [medicalData.weightHeight]);

    useEffect(() => {
        setLoading(true);
        callToServices(false, true);
    }, []);

    useEffect(() => {
        filterDate();
    }, [dateEnd, dateStart]);

    const filterDate = () => {
        setListRegister([]);
        setSkip(0);
        callToServices(true);
    };

    const handleClickExpanded = (i, item) => (e) => {
        if (e.target.innerText === "VER MAS") {
            e.target.innerText = "VER MENOS";
        }
        else {
            e.target.innerText = "VER MAS";
        }
    };


    const lastRecordCard = () => {
        return (
            <>
                <MovementsCard
                    buttonsInHeader={false}
                    headerIcon={
                        <HeaderCard
                            day={lastRecord?.fechaFormateada?.nombreDia}
                            numberDay={lastRecord?.fechaFormateada?.dia}
                            month={parseInt(lastRecord?.registracionFechaHora?.substring(5, 7))}
                            year={lastRecord?.registracionFechaHora?.substr(0, 4)}
                        />
                    }
                    description={
                        <>
                            <Typography style={{ fontWeight: "600", color: '#0075c9' }} className={`${classes.txtCardDescription} `}>
                                <Typography style={{ fontSize: '1rem' }}>
                                    {`Hora: ${lastRecord?.registracionFechaHora?.substr(lastRecord?.registracionFechaHora?.indexOf("T") + 1, 5)} hs`}
                                </Typography>
                            </Typography>
                            <Typography style={{ fontWeight: "600" }} className={`${classes.subTitleMedicalData}`} >
                                <Typography style={{ fontSize: '1rem' }}>
                                    {"PESO Y TALLA"}
                                </Typography>
                            </Typography>
                            <MedicalHistoryWeightHeightCard
                                label="PESO:"
                                value={lastRecord?.peso}
                                suffix=" KG"
                                classes={classes}
                            />

                            <MedicalHistoryWeightHeightCard
                                label="TALLA METROS:"
                                value={lastRecord?.tallaMetros}
                                suffix=" mts"
                                classes={classes}
                            />

                            <MedicalHistoryWeightHeightCard
                                label="TALLA CENTIMETROS:"
                                value={lastRecord?.tallaCentimetros}
                                suffix=" cms"
                                classes={classes}
                            />

                            <MedicalHistoryWeightHeightCard
                                label="IMC:"
                                value={lastRecord?.imc}
                                suffix=" KG/M2"
                                classes={classes}
                            />
                        </>
                    }
                />
            </>
        );
    };

    const addAccordion = (i, item) => {
        return (
            <Accordion key={i} style={{ margin: "10px", padding: "15px" }}>
                <AccordionSummary
                    expandIcon={<CustomButton
                        customClass={`${classes.btnNewWeigth} ${classes.accordionWeightSize} `}
                        title='ver mas'
                        onClick={handleClickExpanded(i, item)}
                    />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                >
                    <Box className={classes.accordionWeightSizeView}>
                        <Typography className={classes.txtSubtitleCalendar}>
                            {"PESO Y TALLA"}
                        </Typography>
                        <Box id={i} style={{ display: "flex" }}>
                            <Typography className={classes.txtSubtitleGray} style={{ marginLeft: "7px" }}>
                                {`${item?.fechaFormateada?.dia} de ${item?.fechaFormateada?.mes} de ${item?.registracionFechaHora?.substr(0, 4)}`}
                            </Typography>
                            <IconButton className={classes.padding0} onClick={() => { handleDelete(item); }} style={{ marginRight: "10px" }}>
                                <DeleteOutlineIcon />
                            </IconButton>
                        </Box>
                    </Box>
                </AccordionSummary>
                <AccordionDetails>
                    <RenderAccordionDetail
                        label="PESO: "
                        value={item.peso}
                        suffix="kg"
                        classes={classes}
                    />

                    <RenderAccordionDetail
                        label="TALLA METROS: "
                        value={`${item.tallaMetros}.${item.tallaCentimetros}`}
                        suffix=" mts"
                        classes={classes}
                    />

                    <RenderAccordionDetail
                        label="IMC: "
                        value={item.imc}
                        suffix="KG/M2"
                        classes={classes}
                    />

                    <RenderAccordionDetail
                        label="FECHA: "
                        value={`${item?.fechaFormateada?.dia} de ${item?.fechaFormateada?.mes} de ${item?.registracionFechaHora?.substr(0, 4)} ${item?.registracionFechaHora?.substr(item?.registracionFechaHora?.indexOf("T") + 1, 5)}`}
                        classes={classes}
                    />
                </AccordionDetails>
            </Accordion>);
    };



    const handleDelete = (item) => {
        var param = {};
        param.numeroPersona = parseInt(window.localStorage.getItem("numeroPersona"));
        param.peso = item.peso;
        param.tallaMetros = item.tallaMetros;
        param.tallaCentimetros = item.tallaCentimetros;
        param.registracionFechaHora = item.registracionFechaHora;
        param.modo = "B";
        props.setAction("BAJA");
        props.setForm(param);
        props.setOpenConfirm(prevState => !prevState);
    };
    const scrollDiv = () => {
        return (screen.sWidth < 800 ? classes.heightDivRegisters : "");
    };

    const handleScroll = (e) => {
        const bottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
        if (bottom) {
            callToServices();
        }
    };

    const callToServices = (tipoFecha, first) => {
        let auxSkip = skip;
        if (dateStart !== null && dateEnd !== null) {
            if (tipoFecha || first) {
                auxSkip = 0;
            } else {
                auxSkip += 10;
            }
            const paramGet = {
                numeroPersona: parseInt(window.localStorage.getItem("numeroPersona")),
                count: 10,
                skip: parseInt(auxSkip),
                fechaDesde: dateStart,
                fechaHasta: dateEnd
            };
            if (lastRequest.current &&
                lastRequest.current.numeroPersona === paramGet.numeroPersona &&
                lastRequest.current.count === paramGet.count &&
                lastRequest.current.fechaDesde === paramGet.fechaDesde &&
                lastRequest.current.fechaHasta === paramGet.fechaHasta) {
                return;
            }
            lastRequest.current = paramGet;
            setSkip(parseInt(auxSkip));
            dispatch(getDataWheightHeight(paramGet));
        }
    };

    const btnIcon = () => {
        return (
            <CustomButton
                title={"NUEVO "}
                onClick={() => { props.setAdd(prevState => !prevState); }}
                customClass={`${classes.btnNewWeigth} ${classes.lightLinearGradient} `}
                style={{ margin: "0 10px" }}
            />
        );
    }

    function showLastRecord(condition) {
        if (condition !== null) {
            var response = (lastRecordCard());
        } else {
            response = (
                <Typography
                    className={`${classes.txtSubtitleBlue} ${classes.txtEllipsis}`}
                    style={{ marginLeft: "20px", marginTop: "15px" }}>{"No se encontraron resultados"}
                </Typography>
            );
        }
        return response;
    }

    function btnVerMas(condition) {
        if (condition > 800) {
            var response = (
                <Box style={{ width: "100%" }} className={classes.BtnMobileWeight}>
                    <CustomButton
                        customClass={`${classes.btnNewWeigth} ${classes.lightLinearGradient}  ${classes.seeMoreIconButton}`}
                        title='ver mas'
                        onClick={() => { callToServices(); }}
                    />
                </Box>
            );
        }
        return response;
    }

    function showAccordion(condition) {
        let response;
        if (condition > 0) {
            response = (
                <> {
                    listRegister?.map((item, i) => (
                        <Box
                            className={`${classAccordion(screen.sWidth, classes)} ${classes.notRotateIcon}`}
                            style={{ maxWidth: "400px", flexShrink: "1", alignItems: "center" }}>
                            {addAccordion(i, item)}
                        </Box>
                    ))}
                    {
                        listRegister?.length >= 10 &&
                        btnVerMas(screen.sWidth)
                    }
                </>
            );
        } else {
            response = (
                <Typography
                    className={`${classes.txtSubtitleBlue} ${classes.txtEllipsis}`}
                    style={{ marginLeft: "20px", marginTop: "15px" }}>
                    {"No se encontraron resultados"}
                </Typography>
            );
        }
        return response;
    }

    function showLastCardRecord(condition) {
        var response;
        if (condition > 768) {
            response = (
                <Box
                    className={widthClass(screen.sWidth, classes)}
                    style={{ marginLeft: "28px" }}
                >
                    {showLastRecord(lastRecord)}
                </Box>
            );
        } else {
            response = (
                <Box
                    className={widthClass(screen.sWidth, classes)}
                    style={{ display: "flex", justifyContent: (lastRecord !== null ? "center" : "start") }}
                >
                    {showLastRecord(lastRecord)}
                </Box>
            );
        }
        return response;
    }

    return (
        <>
            {loading ?
                <Box className={classes.iconLoadMedicalData} ><CircularProgress /></Box>
                :
                <>
                    {
                        screen.sWidth <= 768 &&
                        <Box
                            className={`${classes.medicalDataForm} ${setBackgroundMobile(classes, screen.sWidth)}`}>
                            <IconButton onClick={handleGoToPersonalMedicalData}>
                                <ArrowBackIcon className={classes.ShowMoreArrowIcon} style={{ fontSize: "25px" }} />
                            </IconButton>
                            <Box>
                                <Typography className={`${classes.titleTurn} ${classes.titleBox}`} style={{ textTransform: 'uppercase' }}>
                                    MIS DATOS MEDICOS
                                </Typography>
                                <Typography className={`${classes.titleTurn} ${classes.titleBox} ${classes.subtitleBox}`} style={{ marginRight: "20px" }}>
                                    Información sin carácter sanitario conforme ley Nº 26529
                                </Typography>
                            </Box>
                        </Box>
                    }
                    <Box className={classes.headerSecundary} style={{ marginBottom: "20px", display: "grid", gridTemplateColumns: "1fr 1fr" }}>
                        <Typography className={`${classes.titleTurn} ${classes.titleBox}`} style={{ textTransform: 'uppercase' }}>
                            PESO Y TALLA
                        </Typography>
                        <Typography
                            className={`${classes.titleTurn} ${classes.subtitleBox}  ${classes.medicalDataFormTxtDescription}`}>
                            Información sin carácter sanitario conforme ley Nº 26529
                        </Typography>
                        <Box style={{ gridColumn: "span 1", justifySelf: "right" }} className={classes.headerFiltro}>
                            {btnIcon()}
                            <ShowPeriodFilter
                                dateStart={dateStart}
                                dateEnd={dateEnd}
                                setDateStart={setDateStart}
                                setDateEnd={setDateEnd}
                                openPicker={open}
                                setOpenPicker={setOpen}
                                classes={classes}
                            />
                        </Box>
                    </Box>
                    <Box style={{ marginBottom: "30px" }}>
                        <Typography className={`${classes.titleTurn} ${classes.titleBox}`} >
                            MI ULTIMO REGISTRO
                        </Typography>
                        <Divider className={classes.formDivider} style={{ marginBottom: "20px" }} />
                        {
                            showLastCardRecord(screen.sWidth)
                        }
                    </Box>
                    <Typography className={`${classes.titleTurn} ${classes.titleBox}`} style={{ textTransform: 'uppercase' }}>
                        MIS REGISTROS ANTERIORES
                    </Typography>
                    <Divider className={classes.formDivider} style={{ marginBottom: "10px" }} />
                    <Box
                        className={`${classes.flexRowAcordion} ${scrollDiv()}`}
                        onScroll={(e) => { handleScroll(e); }}
                        style={{ justifyContent: screen.sWidth <= 768 && 'center', marginLeft: screen.sWidth > 768 && '12px' }} >
                        {showAccordion(listRegister?.length)}
                    </Box>
                </>
            }
        </>);
};

export default WeightAndHeigth;

function widthClass(width, classes) {
    if (width <= 800) {
        return classes.width100;
    }
    else if (width > 800 && width < 1250) {
        return classes.width50;
    }
    else {
        return classes.width25;
    }
}

function classAccordion(swidth, classes) {
    if (swidth > 800) {
        return classes.AccordionWeightWeb;
    }
    else {
        return classes.AccordionWeightMobile;
    }
}

function setBackgroundMobile(classes, width) {
    let cssClass = classes.displayNone;
    if (width <= 768) {
        cssClass = classes.titlePersonalDataForm;
    }
    return cssClass;
}
